import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SideBarOptions } from 'src/app/models/sidebar/sidebar.model';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})


export class CommonServiceService {

  public menuStatus = new Subject();
  public booleanValue$ = new BehaviorSubject(false);

  constructor(private http: HttpClient) { }
  
  toggleMenu(){
    this.menuStatus.next(true)
  }

  getSidebarData(): Observable<SideBarOptions> {
    return this.http.get<any>(environment.assetsDataPath + 'sidebar.json');
  }

  emitBooleanValue(value: boolean) {
    this.booleanValue$.next(value)
  }
}
